import { recentListingStatus } from '../_config';
import { usePageStore } from '@/store';

export default {
    //  call get listing  interface   The parameters that need to be passed
    listingParams(state) {
        const pageStore = usePageStore(this.$pinia);
        return {
            ...state.searchParams,
            siteId: pageStore.siteId,
            listingStatus: state.currentListingStatus,
            page: state.pageNum,
            pageSize: state.pageSize
        };
    },
    // recent listing Related status display
    showRecentListingData(state) {
        return (
            (state.fetchListingStatus === recentListingStatus.loading ||
                state.fetchListingStatus === recentListingStatus.loaded) &&
            !state.showRecentListingNoData
        );
    },
    showRecentListingLoading(state) {
        return state.fetchListingStatus === recentListingStatus.loading;
    },
    showRecentListingNoLocation(state) {
        return state.fetchListingStatus === recentListingStatus.noLocation;
    },
    showRecentListingComing(state) {
        return state.fetchListingStatus === recentListingStatus.coming;
    },
    showRecentListingNoData(state) {
        return (
            state.fetchListingStatus !== recentListingStatus.coming &&
            state.fetchListingStatus !== recentListingStatus.noLocation &&
            state.listing.length === 0
        );
    },
    //  whether or not sold listing
    isSoldListing(state) {
        return state.currentListingStatus.toLowerCase() === 'sold';
    }
};
